import React from 'react';
import Layout from '../../components/Layout';
import ServicesHub from './ServicesHub';

const title = 'All Home Services — BestHand';
const description =
  'Browse every BestHand service — cleaning, plumbing, electrical, handyman, moving, TV mounting and more. Book a vetted local pro with upfront, industry-low pricing.';

function action() {
  return {
    title,
    description,
    component: (
      <Layout>
        <ServicesHub />
      </Layout>
    ),
  };
}

export default action;
